import { Absence as LegacyAbsence } from '../../../models'
import { addDays, max } from '../../helpers/date'
import { transformToPeriod } from '../Period/PeriodTransformers'
import { User } from '../User/User'
import { transformToUser } from '../User/UserTransformers'
import { Absence, AbsenceResource } from './Absence'

export const transformToAbsence = (
    resource: AbsenceResource,
    user: User,
): Absence => {
    const { start, end } = resource.attributes
    const startDate = new Date(start)
    const justifiedEndDate = ! end ? addDays(max([startDate, new Date()]), 3) : new Date(end)

    return {
        id: resource.id,
        user,
        period: transformToPeriod(
            startDate,
            justifiedEndDate,
            !! end,
        ),
    }
}

export const transformLegacyAbsenceToAbsence = (
    absence: LegacyAbsence,
): Absence => {
    const startDate = new Date(absence.start)
    const justifiedEndDate = ! absence.end ? addDays(max([startDate, new Date()]), 3) : new Date(absence.end)

    return {
        id: absence.id,
        period: transformToPeriod(
            startDate,
            justifiedEndDate,
            !! absence.end,
        ),
        user: transformToUser({ type: 'users', id: absence.user.id, attributes: absence.user }),
    }
}
